import { FlexCenterBoth, FlexCol } from 'components/primitives/flex';
import { ReactNode } from 'react';
import styled from 'styled-components';
import PanelList, { ListItemEntry } from './PanelList';

interface Props {
  children: ReactNode;
  placeholder?: string;
  showPlaceholder?: boolean;
  items?: ListItemEntry[];
  light?: boolean;
}

const Panel = ({ children = <div />, placeholder, showPlaceholder, items, light = false }: Props) => {
  const renderInside = () => {
    if (showPlaceholder) {
      return <Placeholder text={placeholder} />;
    }
    if (items && items.length) {
      return <PanelList items={items} />;
    }
    return children;
  };
  const WrapperElement = light ? WrapperLight : Wrapper;
  return (
    <WrapperElement>
      <PanelInside>{renderInside()}</PanelInside>
    </WrapperElement>
  );
};

const Placeholder = ({ text }) => (
  <PanelPlaceholder>
    <PanelPlaceholderText>{text}</PanelPlaceholderText>
  </PanelPlaceholder>
);

export default Panel;

const Wrapper = styled.div`
  background: white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
  border-radius: 9px;
  padding: 11px 26px;
  width: 100%;
`;

const WrapperLight = styled(Wrapper)`
  border: 1px solid var(--neutral-divider, #dbdfe5);
  box-shadow: none;
`;

const PanelInside = styled(FlexCol)`
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
`;

const PanelPlaceholder = styled(FlexCenterBoth)`
  align-self: stretch;
  padding: 72px;
  height: 100%;
`;

const PanelPlaceholderText = styled.span`
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #8e9697;
`;
